import { Link } from "react-router-dom/cjs/react-router-dom";
import React, { Suspense, useContext, useEffect, useRef, useState } from "react";
import { getOnlineTraining } from "../../Services/SelfLearning";
const ComponentLoader = React.lazy(() => import("../../../../../Shared/Sidebar/ComponentLoader"));
const MyCourse = (args) => {
    const lastCourse=args.lastCourse
    const [IsIsloading, setIsIsloading] = useState(false);
    const [myCourseList,setMyCourseList] = useState([]);
    let userDetails = JSON.parse(localStorage.getItem("User") || '');
    useEffect(() => {
        // GetOnlineTraining();
    }, [])
    async function GetOnlineTraining() {
        setIsIsloading(true);
        let body = {
            "AccountId": userDetails?.OrgId,
            "LoggedInUserId": userDetails?.EmpId,
            "UserId": userDetails?.EmpId,
            "CourseId": 0,
            "Search": "",
            "PageNumber": 1,
            "CategoryId": 0,
            "PageSize": 100,
            "NewOnly": 0,
            "BookmarkedOnly": 0,
            "FreeOnly": 0,
            "MyCourse": 0
            
        }
        try {
            let response = await getOnlineTraining(body);
            setMyCourseList(response?.Data?.courses[0]); 
            setIsIsloading(false);
        } catch (err) {
            setIsIsloading(false);
        }

    }

    return(
                    <div className="card">
                        <div className="card-body ">
                            <div className="custom-tab-1 latest-recruitment shortlisted">
                                <strong className='upcome'>My Courses</strong>
                                <Link to="" className="more-icon"><i className="fa fa-angle-right"></i></Link>
                                <div className="roundtabs">
                                    <ul className="nav nav-tabs ml-auto">
                                        <li className="nav-item">
                                            <a className="nav-link active" data-bs-toggle="tab" href="#in-progress">In Progress</a>
                                        </li>
                                        <li className="nav-item">
                                            <a className="nav-link" data-bs-toggle="tab" href="#completed">Completed</a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="tab-content">
                                    <div id="in-progress" className="tab-pane active">
                                        <div className="courselist">
                                            <Link to="CourseDetail"><div className="mycourselist">
                                                <div className="imgdiv">
                                                    <img className="avatar is-squared w-100" src="images/org-img/learn/2.jpg" />
                                                    <span className="course-time"><img src="images/org-img/recruitment/time.svg" />2h 30m</span>
                                                </div>
                                                <div className="course-card">
                                                    <span className="leveltag">All Level</span>
                                                    <h3 className="dark-inverted">The Complete Web Development
                                                        Bootcamp</h3>
                                                    <p>Web Development</p>
                                                    <div className="students pb-0">
                                                        <div className="h-avatar is-small">
                                                            <img className="avatar" src="images/avatar/6.jpg" alt="" />
                                                        </div>
                                                        <a className="link is-dark-primary">{lastCourse?.ByName}</a>

                                                    </div>
                                                    <div className="attached-block">
                                                        <ul>
                                                            <li>{lastCourse?.Modules} Module</li>
                                                            <li>{lastCourse?.Lessons} Lesson</li>
                                                            <li>{lastCourse?.Quiz} Quizz</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div></Link>
                                            <Link to="CourseDetail"><div className="mycourselist">
                                                <div className="imgdiv">
                                                    <img className="avatar is-squared w-100" src="images/org-img/learn/3.jpg" />
                                                    <span className="course-time"><img src="images/org-img/recruitment/time.svg" />1h 30m</span></div>
                                                <div className="course-card">
                                                    <span className="leveltag">{lastCourse?.Name}</span>
                                                    <h3 className="dark-inverted">Web Development is Very Easy: A Crash Course</h3>
                                                    <p>SEO</p>
                                                    <div className="students pb-0">
                                                        <div className="h-avatar is-small">
                                                            <img className="avatar" src="images/avatar/5.jpg" alt="" />
                                                        </div>
                                                        <a className="link is-dark-primary">{lastCourse?.ByName}</a>

                                                    </div>
                                                    <div className="attached-block">
                                                        <ul>
                                                            <li>{lastCourse?.Modules} Module</li>
                                                            <li>{lastCourse?.Lessons} Lesson</li>
                                                            <li>{lastCourse?.Quiz} Quizz</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div></Link>
                                            <Link to="CourseDetail"><div className="mycourselist">
                                                <div className="imgdiv">
                                                    <img className="avatar is-squared w-100" src="images/org-img/learn/4.jpg" />
                                                    <span className="course-time"><img src="images/org-img/recruitment/time.svg" />3h 10m</span></div>
                                                <div className="course-card">
                                                    <span className="leveltag">Expert</span>
                                                    <h3 className="dark-inverted">Python Certificate Training</h3>
                                                    <p>Programming</p>
                                                    <div className="students pb-0">
                                                        <div className="h-avatar is-small">
                                                            <img className="avatar" src="images/avatar/5.jpg" alt="" />
                                                        </div>
                                                        <a className="link is-dark-primary">{lastCourse?.ByName}</a>

                                                    </div>
                                                    <div className="attached-block">    
                                                        <ul>
                                                            <li>{lastCourse?.Modules} Module</li>
                                                            <li>{lastCourse?.Lessons} Lesson</li>
                                                            <li>{lastCourse?.Quiz} Quizz</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div></Link>
                                        </div>
                                    </div>
                                    <div id="completed" className="tab-pane fade">
                                        <div className="courselist">
                                            <Link to="CourseDetail"><div className="mycourselist">
                                                <div className="imgdiv">
                                                    <img className="avatar is-squared w-100" src="images/org-img/learn/2.jpg" />
                                                    <span className="course-time"><img src="images/org-img/recruitment/time.svg" />2h 30m</span>
                                                </div>
                                                <div className="course-card">
                                                    <span className="leveltag">All Level</span>
                                                    <h3 className="dark-inverted">The Complete Web Development
                                                        Bootcamp</h3>
                                                    <p>Web Development</p>
                                                    <div className="students pb-0">
                                                        <div className="h-avatar is-small">
                                                            <img className="avatar" src="images/avatar/6.jpg" alt="" />
                                                        </div>
                                                        <a className="link is-dark-primary">{lastCourse?.ByName}</a>

                                                    </div>
                                                    <div className="attached-block">
                                                        <ul>
                                                            <li>{lastCourse?.Modules} Module</li>
                                                            <li>{lastCourse?.Lessons} Lesson</li>
                                                            <li>{lastCourse?.Quiz} Quizz</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                                IsIsloading ? <Suspense >
                                <ComponentLoader />
                            </Suspense> : ''
                            }
                    </div>
                        );
}
export default MyCourse;